import React from "react";
import PropTypes from "prop-types";
import { Stack, Box, Typography, Button, Modal, Fade } from "@mui/material";
import { Close } from "@mui/icons-material";
import JotFormWrapper from "../jotform/JotFormWrapper";
import Loader from "../loader";

const SubmitContactFormModal = ({ openModal, handleCloseModal, isLoading, form }) => {
    return (
        <Modal open={openModal} onClose={handleCloseModal} closeAfterTransition>
            <Fade in={openModal}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "white",
                        boxShadow: 24,
                        p: { xs: 1, lg: 2 },
                        borderRadius: 2,
                        maxHeight: "90vh",
                        width: { xs: "95vw", lg: "70vw" },
                        overflowY: "scroll",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start"
                    }}
                >
                    <Stack
                        direction="column"
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%"
                        }}
                    >
                        <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{ width: "100%", py: 2 }}
                        >
                            <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
                                <Typography
                                    sx={{
                                        fontSize: { xs: "x-large", lg: "xx-large" },
                                        textAlign: "center"
                                    }}
                                >
                                    Contact Form
                                </Typography>
                            </Box>
                            <Button
                                onClick={handleCloseModal}
                                sx={{
                                    minWidth: "auto"
                                }}
                            >
                                <Close />
                            </Button>
                        </Stack>

                        <Box>
                            {isLoading ? (
                                <Loader />
                            ) : (
                                <JotFormWrapper jotFormID={form.jotFormID} />
                            )}
                        </Box>
                    </Stack>
                </Box>
            </Fade>
        </Modal>
    );
};

SubmitContactFormModal.propTypes = {
    openModal: PropTypes.bool.isRequired,
    handleCloseModal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired
};

export default SubmitContactFormModal;
